import React, { useEffect } from 'react';
import './css/Founders.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import DownloadApp from './components/DownloadApp';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images & icons
import aboutHeroBg from '../images/banner-founder-desk.jpg';
import { FaQuoteLeft } from 'react-icons/fa';

// Import placeholder images for team members (replace with actual team image imports)
import jaydeepImg from '../images/Founder1.jpg';
import paramitaImg from '../images/Founder2.jpg';
import parthaImg from '../images/Advisor1.jpg';
import kaushikImg from '../images/Patron1.jpg';
import joyImg from '../images/Patron2.jpg';

function Founders() {
    // Automatically scroll to top when visiting the Founders page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="about-hero-section"
                style={{ backgroundImage: `url(${aboutHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* ==========================================================
                SECTION 1: Founders & Directors
                ========================================================== */}
            <section className="about-grid-bg-section" style={{ backgroundColor: '#fcfdfd' }}>
                <div className="container">

                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">LEADERSHIP & VISION</span>
                            <h2 className="grid-section-heading">Founders & Directors</h2>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {/* Jaydeep Maitra */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box p-0 overflow-hidden h-100">
                                <div className="row g-0 align-items-center h-100">
                                    <div className="col-md-5 founder-img-col">
                                        <img
                                            src={jaydeepImg}
                                            alt="Jaydeep Maitra"
                                            className="founder-box-img img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-7">
                                        <div className="grid-box-text-block p-4">
                                            <h4>Jaydeep Maitra</h4>
                                            <p className="founder-role-title">
                                                Co-founder and Director – Operations & Marketing
                                            </p>
                                            <p>
                                                A much-loved teacher and mentor, Jaydeep has coached
                                                students for success in their boards and at competitive
                                                levels in West Bengal and Mumbai across two and a half
                                                decades. Crestest Learning is his brainchild, born of
                                                his insights from teaching, alongside nearly a decade's
                                                experience in the social sector and a valuable stint in
                                                the corporate world of educational content and
                                                technology.
                                            </p>
                                            <p>
                                                Jaydeep dreams of bringing quality learning within the
                                                reach of students in lower-tier cities, towns, and
                                                underprivileged communities. He is known for bringing
                                                care, depth, and lived wisdom to everything he creates.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Paramita Choudhury */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box p-0 overflow-hidden h-100">
                                <div className="row g-0 align-items-center h-100">
                                    <div className="col-md-5 founder-img-col">
                                        <img
                                            src={paramitaImg}
                                            alt="Paramita Choudhury"
                                            className="founder-box-img img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-7">
                                        <div className="grid-box-text-block p-4">
                                            <h4>Paramita Choudhury</h4>
                                            <p className="founder-role-title">
                                                Co-founder and Director – Planning & HR
                                            </p>
                                            <p>
                                                Paramita is a fierce nurturer, a fighter for love and
                                                justice, a passionate philanthropist, and a mother. A
                                                devoted advocate for animal rights, she has personally
                                                rescued and rehabilitated multiple injured or abandoned
                                                animals. She has also adopted and supported children in
                                                need and has a soft spot for underdogs and late
                                                bloomers.
                                            </p>
                                            <p>
                                                She has demonstrated tough love, resilience, creative
                                                problem-solving, and strong leadership across every role
                                                she has embraced. Crestest is her first entrepreneurial
                                                venture and remains very close to her heart.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ==========================================================
                SECTION 2: Strategy & Finance Advisor
                ========================================================== */}
            <section className="about-grid-bg-section pt-0" style={{ backgroundColor: '#fcfdfd' }}>
                <div className="container">

                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">EXPERT GUIDANCE</span>
                            <h2 className="grid-section-heading">Strategy & Finance</h2>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>

                    <div className="row justify-content-center">

                        {/* Partha */}
                        <div className="col-lg-10">
                            <div className="glass-grid-box p-0 overflow-hidden h-100">
                                <div className="row g-0 align-items-center h-100">
                                    <div className="col-md-5 founder-img-col">
                                        <img
                                            src={parthaImg}
                                            alt="Partha"
                                            className="founder-box-img img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-7">
                                        <div className="grid-box-text-block p-4">
                                            <h4>Partha Choudhury</h4>

                                            <p className="founder-role-title">
                                                Founding Team Member & Advisor – Strategy & Finance
                                            </p>

                                            <p>
                                                A finance professional with around three decades of corporate finance
                                                experience, Partha brings the strategic, financial, and planning
                                                expertise required to transform concepts and ideas into operationally
                                                and commercially viable propositions.
                                            </p>

                                            <p>
                                                Having headed corporate finance, strategic planning, and operational
                                                finance functions across a variety of industries, he has introduced
                                                best practices in corporate governance, operations, and services for
                                                our users.
                                            </p>

                                            <p>
                                                His hands-on involvement provides the stability and financial
                                                discipline needed to support Crestest's ambitious growth vision and
                                                student expansion plans. Partha is generous to a fault, yet able to
                                                hold his centre with razor-sharp discernment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ==========================================================
                SECTION 3: Patrons & Mentors
                ========================================================== */}
            <section className="about-grid-bg-section pt-0" style={{ backgroundColor: '#fcfdfd' }}>
                <div className="container">

                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">LONG-TERM VISION</span>
                            <h2 className="grid-section-heading">Patrons & Advisors</h2>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {/* Kaushik Chanda */}
                        {/* Kaushik Chanda */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box p-0 overflow-hidden h-100">
                                <div className="row g-0 align-items-center h-100">
                                    <div className="col-md-5 founder-img-col">
                                        <img
                                            src={kaushikImg}
                                            alt="Kaushik Chanda"
                                            className="founder-box-img img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-7">
                                        <div className="grid-box-text-block p-4">
                                            <h4>Kaushik Chanda</h4>

                                            <p className="founder-role-title">
                                                Patron
                                            </p>

                                            <p>
                                                A scholar throughout his academic journey and an
                                                engineer by profession with a reputed EPC company in
                                                the USA, Kaushik Chanda brings a grounded yet uplifting
                                                outlook on life. Despite spending more than two decades
                                                abroad, he has remained deeply committed to giving back
                                                to his roots.
                                            </p>

                                            <p>
                                                Known for his warm and approachable personality, he has
                                                quietly contributed to numerous initiatives that benefit
                                                society. His continued support for the growth of his
                                                educational institutions is highly valued.
                                            </p>

                                            <p>
                                                Inspired to make a meaningful difference in education,
                                                Kaushik now serves as a Patron of Crestest Learning,
                                                supporting its mission of empowering students through
                                                quality education.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Joy Mukherjee */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box p-0 overflow-hidden h-100">
                                <div className="row g-0 align-items-center h-100">
                                    <div className="col-md-5 founder-img-col">
                                        <img
                                            src={joyImg}
                                            alt="Joy Mukherjee"
                                            className="founder-box-img img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-7">
                                        <div className="grid-box-text-block p-4">
                                            <h4>Joy Mukherjee</h4>

                                            <p className="founder-role-title">
                                                Patron & Advisor – Marketing
                                            </p>

                                            <p>
                                                Joy Mukherjee has had an illustrious career spanning
                                                more than three decades with a global electrical
                                                engineering giant, where he has played a pivotal role
                                                in driving business growth and success across finance,
                                                marketing, and talent management.
                                            </p>

                                            <p>
                                                Crestest is delighted to have him as a Patron and
                                                Advisor, benefiting from his extensive experience in
                                                business development, people management, and his deep
                                                understanding of the aspirations of the younger
                                                generation.
                                            </p>

                                            <p>
                                                An electrical engineer by qualification, Joy has
                                                interests ranging from electrical grid products and
                                                sustainable technologies to digital solutions and cyber
                                                security. He is also a dedicated Rotarian and actively
                                                supports several initiatives that uplift underprivileged
                                                communities across the country.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            {/* <DownloadApp /> */}

            {/* 4. Founder's Quote / Message Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="p-5 text-center position-relative quote-box-wrapper">
                                <FaQuoteLeft
                                    className="mb-3"
                                    style={{
                                        fontSize: "40px",
                                        color: "#57BDB9",
                                        opacity: 0.6,
                                    }}
                                />

                                <h3
                                    className="mb-4"
                                    style={{
                                        color: "#207AB4",
                                        fontWeight: "800",
                                        fontSize: "24px",
                                    }}
                                >
                                    A Message From The Founders
                                </h3>

                                <p className="lead px-md-4 quote-text">
                                    <strong>Dear Students,</strong>
                                    <br />
                                    <br />
                                    Learning something well brings a unique sense of
                                    fulfillment. Remaining steadfast in the face of repeated
                                    failures and setbacks, and eventually touching that
                                    elusive rainbow of achievement is a feeling like no
                                    other. That is the true measure of success and
                                    accomplishment in life. If you nurture dreams of
                                    attaining the highest milestones, then you must harness
                                    that unbridled energy within and embrace the principles
                                    of rigour and discipline to drive forward.
                                    <br />
                                    <br />
                                    Each day you should seek to be better than your previous
                                    self. Consistently eclipsing one's own achievements is a
                                    stronger and more reliable measure of sustained progress
                                    than any reassurances derived from competing with
                                    others. Often, hurdles and headwinds spark a defiant
                                    determination that allows individuals to unceasingly
                                    strive towards their goals. It appears providential that
                                    they then become shining examples of excellence—beacons
                                    for all that is attainable for the tireless and the
                                    enterprising. This innate potential resides in each and
                                    every one of you.
                                    <br />
                                    <br />
                                    We at <strong>Crestest Learning</strong> extend warm
                                    wishes and heartfelt prayers for all our students to
                                    succeed in their scholastic endeavours and achieve
                                    brighter futures than they could even have imagined!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* 5. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Founders;